export const HighRisk = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"><path stroke="#1470CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.5 27.04 14.386 20l4.114 7.5 4.09-15 4.41 11 3.5-12" /><path stroke="#1470CC" stroke-dasharray="1 3" stroke-linecap="round" d="M9 9.5v21M31 9.5v21" opacity=".6" /></svg>
    )
}